export default __webpack_public_path__ + "static/3-3b554c5647f946d07b3f0e80ec5dd5e8.jpeg";